// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import axios from "axios";
// import { Pie, Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   ArcElement,
//   Tooltip,
//   Legend,
//   BarElement,
//   CategoryScale,
//   LinearScale,
// } from "chart.js";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import { Spin } from "antd"; // Add Spin

// // Register necessary chart components
// ChartJS.register(
//   ArcElement,
//   Tooltip,
//   Legend,
//   BarElement,
//   CategoryScale,
//   LinearScale
// );

// const Dashboard = () => {
//   const navigate = useNavigate();
//   const [count, setCount] = useState({
//     customer: 0,
//     book: 0,
//     employee: 0,
//   });
//   const [loading, setLoading] = useState(false); // Loader state
//   const authData = localStorage.getItem("auth");

//   const authObject = JSON.parse(authData);
//   console.log("authObject", authObject);

//   const token = authObject?.accessToken;
//   console.log("token", token);
//   useEffect(() => {
//     getData();
//     // getEmployedata();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);
//   const getData = async () => {
//     setLoading(true); // Start loader
//     try {
//       const response = await axios.get(
//         "http://localhost:4000/user/getAllOrders",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       console.log("response", response);
//       console.log("response.data.data.count", response.data.data.count);

//       const customerResposne = await axios.get(
//         "http://localhost:4000/user/getAllUsers",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       console.log("customerResposne", customerResposne);

//       // Only count users with role === "provider"
//       const users = customerResposne.data.data.filterUser || [];
//       const providerCount = users.filter(u => u.role === "provider").length;


//       const EmployeeResposne = await axios.get(
//         "http://localhost:4000/user/getAllUsers",
//         {
//           headers: { Authorization: `Bearer ${token}` },
//         }
//       );
//       console.log("EmployeeResposne", EmployeeResposne);

//       // Only count users with role === "user"
//       const Emp = EmployeeResposne.data.data.filterUser || [];
//       const userCount = Emp.filter(u => u.role === "user").length;
//       // Assuming response.data.users and response.data.bookings are arrays
//       setCount({
//         book: response.data.data.count,
//         employee: providerCount,
//         customer: userCount,
//       });
//       console.log(response.data.count); // Log the count of booked orders
//       console.log(customerResposne.data.count);
//     } catch (error) {
//       console.error("Error fetching user and booking data:", error);
//     }
//     setLoading(false); // Stop loader
//   };

//   const chartData = {
//     labels: ["Users", "Orders", "Employees"],
//     datasets: [
//       {
//         data: [count.customer, count.book, count.employee],
//         backgroundColor: [
//           "#FFD700", // Gold for Users
//           "#2196F3", // Blue for Orders
//           "#43A047", // Green for Employees
//         ],
//         hoverBackgroundColor: [
//           "#FFC107", // Amber for Users
//           "#1976D2", // Dark Blue for Orders
//           "#388E3C", // Dark Green for Employees
//         ],
//       },
//     ],
//   };

//   const barOptions = {
//     indexAxis: 'y', // Makes the bar chart horizontal, similar in layout to a pie chart
//     scales: {
//       x: {
//         beginAtZero: true,
//         ticks: {
//           precision: 0,
//         },
//       },
//       y: {
//         ticks: {
//           color: "#4A5568", // Adjust y-axis label color if needed
//         },
//       },
//     },
//     plugins: {
//       legend: {
//         display: false, // Hide legend to keep it similar to pie chart
//       },
//     },
//   };

//   return (
//     <Spin spinning={loading} tip="Processing...">
//       <div className=''>
//         <h3 className='mb-4 text-xl'>Dashboard</h3>

//         <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-6'>
//           {/* Orders Card */}
//           <div
//             className='bg-blue-100 p-10 rounded-lg shadow-md text-center hover:bg-blue-200 transition duration-300 cursor-pointer'
//             onClick={() => navigate("/admin/orders")}
//           >
//             <i className='fas fa-box text-5xl mb-4 text-blue-600'></i>
//             <div className='text-2xl mb-2'>Orders</div>
//             <div className='text-3xl font-semibold text-blue-800 mt-4'>
//               {count.book}
//             </div>
//           </div>

//           {/* Employees Card */}
//           <div
//             className='bg-green-100 p-10 rounded-lg shadow-md text-center hover:bg-green-200 transition duration-300 cursor-pointer'
//             onClick={() => navigate("/admin/employees")}
//           >
//             <i className='fas fa-users text-5xl mb-4 text-green-600'></i>
//             <div className='text-2xl mb-2'>Employees</div>
//             <div className='text-3xl font-semibold text-green-800 mt-4'>
//               {count.employee}
//             </div>
//           </div>
//           {/* Users Card */}
//           <div
//             className='bg-yellow-100 p-10 rounded-lg shadow-md text-center hover:bg-yellow-200 transition duration-300 cursor-pointer'
//             onClick={() => navigate("/admin/customers")}
//           >
//             <i className='fas fa-user text-5xl mb-4 text-yellow-600'></i>
//             <div className='text-2xl mb-2'>Users</div>
//             <div className='text-3xl font-semibold text-yellow-800 mt-4'>
//               {count.customer}
//             </div>
//           </div>

//           {/* Revenue Card */}
//           <div
//             className='bg-purple-100 p-10 rounded-lg shadow-md text-center hover:bg-purple-200 transition duration-300 cursor-pointer'
//             onClick={() => navigate("/admin/revenue")}
//           >
//             <i className='fas fa-coins text-5xl mb-4 text-purple-600'></i>
//             <div className='text-2xl mb-2'>Revenue</div>
//             <div className='text-3xl font-semibold text-purple-800 mt-4'>
//               {/* {count.customer} */}
//             </div>
//           </div>
//         </div>

//         {/* Pie and Histogram Charts */}
//         <div className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
//           {/* Pie Chart */}
//           <div className='bg-white p-4 rounded-lg shadow-sm'>
//             <h4 className='mb-4 text-lg'>
//               Customer, Orders, and Employees Overview
//             </h4>
//             <div className='w-80 h-auto lg:w-80 lg:h-auto'>
//               <Pie data={chartData} />
//             </div>
//           </div>

//           {/* Histogram (Bar) Chart */}
//           <div className='bg-white p-4 rounded-lg shadow-sm'>
//             <h4 className='mb-4 text-lg'>
//               Histogram of Users, Orders, and Employees
//             </h4>
//             <div className='w-80 h-auto lg:w-80 lg:h-auto'>
//               <Bar data={chartData} options={barOptions} />
//             </div>
//           </div>
//         </div>
//       </div>
//     </Spin>
//   );
// };

// export default Dashboard;
// /* crud manage service dashboard
// feedback auto show


// */
// /* crud manage service dashboard
// feedback auto show


// */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Pie, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { Spin } from "antd";

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale
);

const Dashboard = () => {
  const navigate = useNavigate();
  const [count, setCount] = useState({
    customer: 0,
    activeUsers: 0,
    blockedUsers: 0,
    book: 0,
    pendingOrders: 0,
    completedOrders: 0,
    employee: 0,
  });
  const [loading, setLoading] = useState(false);

  const authData = localStorage.getItem("auth");
  const authObject = JSON.parse(authData);
  const token = authObject?.accessToken;

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoading(true);
    try {
      // --- 1️⃣ Fetch all orders ---
      const orderRes = await axios.get(
        `${API_BASE}/user/getAllOrders`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const orders = orderRes.data.data.bookedOrders || [];
      const totalOrders = orders.length;
      const pendingOrders = orders.filter(
        (o) => o.status === "Pending"
      ).length;
      const completedOrders = orders.filter(
        (o) => o.status === "Completed"
      ).length;

      // --- 2️⃣ Fetch all users ---
      const usersRes = await axios.get(
        `${API_BASE}/user/getAllUsers`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const allUsers = usersRes.data.data.filterUser || [];
      const providerCount = allUsers.filter(
        (u) => u.role === "provider"
      ).length;
      const customerCount = allUsers.filter(
        (u) => u.role === "user"
      ).length;
      const activeUsers = allUsers.filter(
        (u) => u.status === "active"
      ).length;
      const blockedUsers = allUsers.filter(
        (u) => u.status === "blocked"
      ).length;

      setCount({
        book: totalOrders,
        pendingOrders,
        completedOrders,
        employee: providerCount,
        customer: customerCount,
        activeUsers,
        blockedUsers,
      });
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
    setLoading(false);
  };

  // 📊 Chart data
  const chartData = {
    labels: ["Users", "Orders", "Employees"],
    datasets: [
      {
        data: [count.customer, count.book, count.employee],
        backgroundColor: ["#FFD700", "#2196F3", "#43A047"],
        hoverBackgroundColor: ["#FFC107", "#1976D2", "#388E3C"],
      },
    ],
  };

  const barOptions = {
    indexAxis: "y",
    scales: {
      x: { beginAtZero: true, ticks: { precision: 0 } },
    },
    plugins: {
      legend: { display: false },
    },
  };
const API_BASE = process.env.REACT_APP_API_BASE;

  return (
    <Spin spinning={loading} tip="Loading...">
      <div>
        <h3 className="mb-4 text-xl font-semibold">Dashboard</h3>

        {/* ===== Summary Cards ===== */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 mb-6">

          {/* 🟦 Orders Card */}
          <div
            className="bg-blue-100 p-10 rounded-lg shadow-md text-center hover:bg-blue-200 transition duration-300 cursor-pointer"
            onClick={() => navigate("/admin/orders")}
          >
            <i className="fas fa-box text-5xl mb-4 text-blue-600"></i>
            <div className="text-2xl mb-2">Orders</div>
            <div className="text-3xl font-semibold text-blue-800 mt-4">
              {count.book}
            </div>
            <div className="text-sm mt-2">
              <span className="text-red-600 font-semibold">
                Pending: {count.pendingOrders}
              </span>{" "}
              |{" "}
              <span className="text-green-600 font-semibold">
                Completed: {count.completedOrders}
              </span>
            </div>
          </div>

          {/* 🟩 Employees Card */}
          <div
            className="bg-green-100 p-10 rounded-lg shadow-md text-center hover:bg-green-200 transition duration-300 cursor-pointer"
            onClick={() => navigate("/admin/employees")}
          >
            <i className="fas fa-users text-5xl mb-4 text-green-600"></i>
            <div className="text-2xl mb-2">Employees</div>
            <div className="text-3xl font-semibold text-green-800 mt-4">
              {count.employee}
            </div>
          </div>

          {/* 🟨 Users Card */}
          <div
            className="bg-yellow-100 p-10 rounded-lg shadow-md text-center hover:bg-yellow-200 transition duration-300 cursor-pointer"
            onClick={() => navigate("/admin/customers")}
          >
            <i className="fas fa-user text-5xl mb-4 text-yellow-600"></i>
            <div className="text-2xl mb-2">Users</div>
            <div className="text-3xl font-semibold text-yellow-800 mt-4">
              {count.customer}
            </div>
            <div className="text-sm mt-2">
              <span className="text-green-700 font-semibold">
                Active: {count.activeUsers}
              </span>{" "}
              |{" "}
              <span className="text-red-700 font-semibold">
                Blocked: {count.blockedUsers}
              </span>
            </div>
          </div>

          {/* 🟪 Revenue Card */}
          <div
            className="bg-purple-100 p-10 rounded-lg shadow-md text-center hover:bg-purple-200 transition duration-300 cursor-pointer"
            onClick={() => navigate("/admin/revenue")}
          >
            <i className="fas fa-coins text-5xl mb-4 text-purple-600"></i>
            <div className="text-2xl mb-2">Revenue</div>
            <div className="text-3xl font-semibold text-purple-800 mt-4">—</div>
          </div>
        </div>

        {/* ===== Charts Section ===== */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="bg-white p-4 rounded-lg shadow-sm">
            <h4 className="mb-4 text-lg font-medium">
              Customer, Orders, and Employees Overview
            </h4>
            <div className="w-80 mx-auto">
              <Pie data={chartData} />
            </div>
          </div>

          <div className="bg-white p-4 rounded-lg shadow-sm">
            <h4 className="mb-4 text-lg font-medium">
              Histogram of Users, Orders, and Employees
            </h4>
            <div className="w-80 mx-auto">
              <Bar data={chartData} options={barOptions} />
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default Dashboard;
